import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const WarningOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 64 64"
    sx={{ width: '64px', height: '64px', color: 'error.main' }}
    {...props}
  >
    <path
      d="M32 15.9732L52.08 50.6665H11.92L32 15.9732ZM7.30666 47.9998C5.25333 51.5465 7.81333 55.9998 11.92 55.9998H52.08C56.1867 55.9998 58.7467 51.5465 56.6933 47.9998L36.6133 13.3065C34.56 9.75982 29.44 9.75982 27.3867 13.3065L7.30666 47.9998ZM29.3333 29.3332V34.6665C29.3333 36.1332 30.5333 37.3332 32 37.3332C33.4667 37.3332 34.6667 36.1332 34.6667 34.6665V29.3332C34.6667 27.8665 33.4667 26.6665 32 26.6665C30.5333 26.6665 29.3333 27.8665 29.3333 29.3332ZM29.3333 42.6665H34.6667V47.9998H29.3333V42.6665Z"
      fill="inherit"
    />
  </SvgIcon>
)
